import React from "react";

function Failed({elem}) {
  return (
    <div className="col-md-6 mb-4">
      <div className="newtask failed_task">
      <div className="date">
          <span className="high">{elem.category}</span>
          <p>{elem.date}</p>
        </div>
        <h2>{elem.title}</h2>
        <p>
          {elem.description}
        </p>
      </div>
    </div>
  );
}

export default Failed;
